/**
 * Who may export an album: its owner, and anyone with a role other than read_only.
 * A missing role (not loaded yet, or an anonymous share-link viewer) may not.
 */
export function canExportAlbum(role: string | null | undefined, isOwner = false): boolean {
  if (isOwner) return true;
  return !!role && role !== 'read_only';
}
